import { render, staticRenderFns } from "./courseItemCommon.vue?vue&type=template&id=6d62662e&scoped=true"
import script from "./courseItemCommon.vue?vue&type=script&lang=js"
export * from "./courseItemCommon.vue?vue&type=script&lang=js"
import style0 from "./courseItemCommon.vue?vue&type=style&index=0&id=6d62662e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d62662e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d62662e')) {
      api.createRecord('6d62662e', component.options)
    } else {
      api.reload('6d62662e', component.options)
    }
    module.hot.accept("./courseItemCommon.vue?vue&type=template&id=6d62662e&scoped=true", function () {
      api.rerender('6d62662e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/courseItemCommon.vue"
export default component.exports